/**
 * view.js — Image Button Gallery (front end only)
 *
 * Adds .is-in-view to each .image-button__item the first time it enters
 * the viewport, but only inside galleries with the "Animate" toggle on
 * (.ibg-animate). The fade-in itself is handled in style.scss.
 */

document.addEventListener("DOMContentLoaded", () => {
	const items = document.querySelectorAll(
		".wp-block-chris-radtke-portfolio-blocks-image-button-gallery.ibg-animate .image-button__item",
	);

	if (!items.length) {
		return;
	}

	// Fallback for very old browsers: just show everything.
	if (!("IntersectionObserver" in window)) {
		items.forEach((item) => item.classList.add("is-in-view"));
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("is-in-view");
					observer.unobserve(entry.target); // fire once only
				}
			});
		},
		{ threshold: 0.15 },
	);

	items.forEach((item) => observer.observe(item));
});
